import { loadScript } from 'shared/dom'

export default class GoogleMapsApi {

  constructor (config) {
    this.config = config
  }

  async _initializeMaps ({ channel, client, libraries, version }) {
    let qs = `v=${version}&client=${client}&libraries=${libraries}`
    qs = qs + (channel ? `&channel=${channel}` : '')
    await loadScript(`https://maps.googleapis.com/maps/api/js?${qs}`)
    return window.google.maps
  }

  async verifyGoogleMapsScriptLoad () {
    if (!this.maps) {
      this.maps = this._initializeMaps(this.config)
    }

    const maps = await this.maps
    return new Promise((resolve) => {
      resolve(maps)
    })
  }

  async geocode (location) {
    if (!this.maps) {
      this.maps = this._initializeMaps(this.config)
    }

    const maps = await this.maps
    const geocoder = new maps.Geocoder()
    return new Promise((resolve) => {
      geocoder.geocode({
        address: location,
      }, (result, status) => {
        if (status === 'OK') { resolve(result) }
        if (status === 'ZERO_RESULTS') { resolve([]) }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/google/maps/api.js